import React from 'react';
import { BookOpen, Zap, Heart } from 'lucide-react';
export function WhatInsideSection() {
  return <section className="py-20 bg-[#FDF6EC]" data-id="element-212">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-213">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-center text-[#2C1810] mb-16" data-id="element-214">
          ¿Qué incluye la guía?
        </h2>

        <div className="space-y-8" data-id="element-215">
          {/* Item 1 */}
          <div className="flex flex-col md:flex-row items-center bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition duration-300" data-id="element-216">
            <div className="w-full md:w-1/3 h-64 bg-[#F5A623] flex items-center justify-center p-8" data-id="element-217">
              <BookOpen className="w-24 h-24 text-[#2C1810] opacity-80" data-id="element-218" />
            </div>
            <div className="w-full md:w-2/3 p-8 md:p-12" data-id="element-219">
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-[#2C1810] mb-4" data-id="element-220">
                The Latino Pantry Swap
              </h3>
              <p className="font-body text-lg text-gray-700 mb-4" data-id="element-221">
                Los 5 productos que están saboteando tu abdomen (y sus
                sustitutos idénticos en sabor).
              </p>
              <ul className="space-y-2" data-id="element-222">
                <li className="flex items-center text-gray-600" data-id="element-223">
                  <span className="w-2 h-2 bg-[#D4522A] rounded-full mr-3" data-id="element-224"></span>
                  Deja de comprar "Healthy" que engorda
                </li>
                <li className="flex items-center text-gray-600" data-id="element-225">
                  <span className="w-2 h-2 bg-[#D4522A] rounded-full mr-3" data-id="element-226"></span>
                  Marcas exactas que encuentras en Walmart
                </li>
              </ul>
            </div>
          </div>

          {/* Item 2 */}
          <div className="flex flex-col md:flex-row-reverse items-center bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition duration-300" data-id="element-227">
            <div className="w-full md:w-1/3 h-64 bg-[#D4522A] flex items-center justify-center p-8" data-id="element-228">
              <Zap className="w-24 h-24 text-white opacity-80" data-id="element-229" />
            </div>
            <div className="w-full md:w-2/3 p-8 md:p-12" data-id="element-230">
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-[#2C1810] mb-4" data-id="element-231">
                Protocolo "Anti-Fatiga de Decisión"
              </h3>
              <p className="font-body text-lg text-gray-700 mb-4" data-id="element-232">
                No pienses más. Abre la guía, elige una cena y en 7 minutos
                estás sentada disfrutando.
              </p>
              <ul className="space-y-2" data-id="element-233">
                <li className="flex items-center text-gray-600" data-id="element-234">
                  <span className="w-2 h-2 bg-[#F5A623] rounded-full mr-3" data-id="element-235"></span>
                  Menús semanales pre-armados
                </li>
                <li className="flex items-center text-gray-600" data-id="element-236">
                  <span className="w-2 h-2 bg-[#F5A623] rounded-full mr-3" data-id="element-237"></span>
                  Lista de compras interactiva
                </li>
              </ul>
            </div>
          </div>

          {/* Item 3 */}
          <div className="flex flex-col md:flex-row items-center bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition duration-300" data-id="element-238">
            <div className="w-full md:w-1/3 h-64 bg-[#2D6A4F] flex items-center justify-center p-8" data-id="element-239">
              <Heart className="w-24 h-24 text-white opacity-80" data-id="element-240" />
            </div>
            <div className="w-full md:w-2/3 p-8 md:p-12" data-id="element-241">
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-[#2C1810] mb-4" data-id="element-242">
                El Secreto del Sazón Fit
              </h3>
              <p className="font-body text-lg text-gray-700 mb-4" data-id="element-243">
                Cómo usar las especias correctas para que tu comida sepa a
                "casa" pero funcione como "quemador de grasa".
              </p>
              <ul className="space-y-2" data-id="element-244">
                <li className="flex items-center text-gray-600" data-id="element-245">
                  <span className="w-2 h-2 bg-[#D4522A] rounded-full mr-3" data-id="element-246"></span>
                  Adiós al pollo hervido y seco
                </li>
                <li className="flex items-center text-gray-600" data-id="element-247">
                  <span className="w-2 h-2 bg-[#D4522A] rounded-full mr-3" data-id="element-248"></span>
                  Mezclas de especias caseras
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}